import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { WebserviceService } from '../services/webservice.service';

@Injectable()
export class CountriesResolver implements Resolve<boolean> {
  constructor(private apiService: WebserviceService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.apiService.commonMethod('getCountries', '', 'GET');
  }
}
